const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/pos',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig